import { deviceConstants } from '../Constants';

const initialState =  {
    loading: false,
    status: '',
    deviceList: [],
    clusters: []
};
  
const updateObject = (oldObject, updatedValues) => {
    return {
        ...oldObject,
        ...updatedValues
    }
};

const setArrayImmutable = (arr, i, value) => Object.assign([...arr], {[i]: value});

export function device(state = initialState, action) {
    switch (action.type) {
        case deviceConstants.REQUEST_USER_DEVICES:
            return updateObject(state, {loading: true})
        
        case deviceConstants.UPDATE_DEVICE_LIST:
            return updateObject(state, {
                deviceList: action.data.devices,
                loading: false
            });
    
        case deviceConstants.GET_DEVICE_DATA:
            return updateObject(state, {loading: true})
        
        case deviceConstants.UPDATE_DEVICE_DATA:
            let updateDeviceId = action.data.deviceId;
            let updateDeviceIndex = -1;

            for (let i = 0; i < state.deviceList.length && updateDeviceIndex === -1; i++){
                if (updateDeviceId === state.deviceList[i].id){
                    updateDeviceIndex = i;
                }
            }

            if (updateDeviceIndex !== -1){
                //let updatedList = Object.assign([...state.deviceList], {
                //    [updateDeviceIndex] : Object.assign({}, 
                //        state.deviceList[updateDeviceIndex], 
                //        action.data.data)
                //})
                let update = Object.assign({}, 
                    state.deviceList[updateDeviceIndex], {data: action.data.data})
                return updateObject(state, {
                    loading: false,
                    deviceList: setArrayImmutable(state.deviceList, 
                        updateDeviceIndex, update)
                });    
            }
            
            return updateObject(state, {
                loading: false
            });
        
        // Clusters
        case deviceConstants.REQUEST_USER_CLUSTERS:
        case deviceConstants.REQUEST_CLUSTER_DEVICES:
        case deviceConstants.REQUEST_CLUSTER_DEVICE_DATA:
                return updateObject(state, {
                    loading: true, 
                    status: '', 
                    moreData: [], 
                    weekStats: []
                });

        case deviceConstants.REQUEST_MORE_CLUSTER_DATA:
                return updateObject(state, {loading: true, status: ''});
    
        case deviceConstants.UPDATE_CLUSTER_LIST:
            return updateObject(state, {
                clusters: action.data.clusters,
                loading: false,
                status: 'ok'
            });

        case deviceConstants.FAIL_CLUSTER_LIST:
            return updateObject(state, {
                clusters: [],
                loading: false,
                status: 'err:Getting User Clusters'
            });

        case deviceConstants.UPDATE_CLUSTER_DEVICES:
            {
                let update = Object.assign({}, state.clusters[action.cluster], 
                    {devices: action.data.devices});
                return updateObject(state, {
                    loading: false,
                    clusters: setArrayImmutable(state.clusters, action.cluster, update),
                    status: 'ok'
                });
            }
        
        case deviceConstants.FAIL_CLUSTER_DEVICES:
            {
                let update = Object.assign({}, state.clusters[action.cluster], 
                    {devices: []});
                return updateObject(state, {
                    loading: false,
                    clusters: setArrayImmutable(state.clusters, action.cluster, update),
                    status: 'err:Getting Cluster ' + action.cluster + ' Devices'
                });
            }

        case deviceConstants.UPDATE_CLUSTER_DEVICE_DATA:    
            {
                let update = Object.assign({}, state.clusters[action.cluster].devices[action.device], 
                    {data: action.data, stats: action.stats})
                let updatedDevice = setArrayImmutable(state.clusters[action.cluster].devices, 
                    action.device, update);
                let updatedCluster = {...state.clusters[action.cluster]};
                updatedCluster.devices = updatedDevice;
                return updateObject(state, {
                    loading: false,
                    clusters: setArrayImmutable(state.clusters, action.cluster, updatedCluster),
                    status: 'ok'
                });
            }
        
        case deviceConstants.FAIL_CLUSTER_DEVICE_DATA:    
            {    
                let update = Object.assign({}, state.clusters[action.cluster].devices[action.device], 
                    {
                        data: [], 
                        stats: {
                            npsScore: NaN, 
                            aButtonPresses: 0, 
                            bButtonPresses: 0, 
                            cButtonPresses: 0,
                            dButtonPresses: 0,
                            eButtonPresses: 0
                        }
                    });
                let updatedDevice = setArrayImmutable(state.clusters[action.cluster].devices, 
                    action.device, update);
                let updatedCluster = {...state.clusters[action.cluster]};
                updatedCluster.devices = updatedDevice;
                return updateObject(state, {
                    loading: false,
                    clusters: setArrayImmutable(state.clusters, action.cluster, updatedCluster),
                    status: 'err:Getting Device ' + action.device + 
                        ' Data for Cluster ' + action.cluster
                });
            }
            
        case deviceConstants.UPDATE_MORE_CLUSTER_DATA:    
            {
                let update = Object.assign({}, state.clusters[action.cluster].devices[action.device], 
                    {moreData: action.data, weekStats: action.stats})
                let updatedDevice = setArrayImmutable(state.clusters[action.cluster].devices, 
                    action.device, update);
                let updatedCluster = {...state.clusters[action.cluster]};
                updatedCluster.devices = updatedDevice;
                return updateObject(state, {
                    loading: false,
                    clusters: setArrayImmutable(state.clusters, action.cluster, updatedCluster),
                    status: 'ok'
                });
            }
        
        case deviceConstants.FAIL_MORE_CLUSTER_DATA:    
            {    
                let update = Object.assign({}, state.clusters[action.cluster].devices[action.device], 
                    {
                        moreData: [], 
                        weekStats: []
                    });
                let updatedDevice = setArrayImmutable(state.clusters[action.cluster].devices, 
                    action.device, update);
                let updatedCluster = {...state.clusters[action.cluster]};
                updatedCluster.devices = updatedDevice;
                return updateObject(state, {
                    loading: false,
                    clusters: setArrayImmutable(state.clusters, action.cluster, updatedCluster),
                    status: 'err:Getting Device ' + action.device + 
                        ' Data for Cluster ' + action.cluster
                });
            }

        default:
            return state
    }
}